import { Paper, Stack, Typography } from '@mui/material'
import { TCheckoutValueType } from '../../../core/types/CheckoutOrder'
import { checkoutRecipientTheme } from './CheckoutRecipientTheme'

const CheckoutRecipientTag = ({
  description,
  valueType,
}: {
  description: string
  valueType: TCheckoutValueType
}) => {
  const { backgroundColor, color } = checkoutRecipientTheme[valueType]

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'inline-flex',
        padding: '2px 8px',
        marginLeft: '6px',
        backgroundColor,
        borderRadius: '16px',
        maxWidth: 'fit-content',
        verticalAlign: 'middle',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Paper
          elevation={0}
          sx={{
            width: '6px',
            height: '6px',
            backgroundColor: color,
            borderRadius: '16px',
          }}
        />
        <Typography
          fontSize="12px"
          lineHeight="18px"
          color={color}
          fontWeight={500}
        >
          {description}
        </Typography>
      </Stack>
    </Paper>
  )
}

export default CheckoutRecipientTag
